module.exports = __webpack_public_path__ + "static/media/RoomService_Meal1_Summary_Page2_Order.4fc4db33.png";